
import { MalSite } from '../../models';

export interface MalSiteState {
    malSites: MalSite[];
}

export const SET_MAL_SITE = 'SET_MAL_SITE';

export interface SetMalSite {
    type: typeof SET_MAL_SITE;
    payload: MalSiteState;
}

export type MalSiteActionTypes = SetMalSite;